import {
  Box,
  Flex,
  HStack,
  Modal,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useContext, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { AiOutlineEye } from 'react-icons/ai';
import { IoEyeOffOutline } from 'react-icons/io5';
import { MdOutlineFileCopy } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import { FireIcon } from '../../../../../assets/icons/FireIcon';
import { StepsLead } from '../../../../../components/white-label/StepsLead';
import { VectorIcon } from '../../../../../components/white-label/VectorIcon';
import { LeadBtnTooltipComponent } from '../../../../../components/widgets/Tooltip';
import FilterContext from '../../../../../contexts/FilterContext';
import RatingFormContext from '../../../../../contexts/RatingContext';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getDadosLogin } from '../../../../../utils/dados-login.util';
import { getProductName } from '../../../../../utils/leads.util';
import { getTelephoneOrCellPhoneNumber } from '../../gestao/utils/getTelephoneOrCellPhoneNumber';
import ModalChangeStatus from './ModalChangeStatus';

type LeadStatus =
  | 'Novas Oportunidades'
  | 'NovoContato'
  | 'EmNegociacao'
  | 'Concluido';

type ShowOrHidePhoneProps = {
  phone: string;
  celphone: string;
  canShow: boolean;
};

const dateFnsDayPeriod = {
  'da manhã': 'Manhã',
  'da tarde': 'Tarde',
  'da noite': 'Noite'
};

export const KanbanDnd = () => {
  const initalFilters = {
    query: {
      status: '',
      'data-inicial': '',
      'data-final': '',
      campanha: '',
      'abordagem-n2': '',
      produto: '',
      abordagem: ''
    },
    headers: {
      cpf: '',
      cnpj: ''
    }
  };

  const { isOpen, onOpen, onClose } = useDisclosure();

  const toast = useToast();
  const {
    currentPageOportunidades,
    setCurrentPageOportunidades,
    currentPageNovoContato,
    setCurrentPageNovoContato,
    currentPageEmNegociacao,
    setCurrentPageEmNegociacao,
    currentPageConcluido,
    setCurrentPageConcluido,
    leads,
    setLeads,
    filterObject,
    setLoadingFilters,
    orderBy
  } = useContext(FilterContext);

  const { stepState, setStepState } = useContext(RatingFormContext);

  // const [data, setData] = useState<any>({
  //   oportunidades: [],
  //   novoContato: [],
  //   emNegociacao: [],
  //   concluidos: []
  // });

  const [qtdState, setQtdState] = useState<any>({
    'Novas Oportunidades': 0,
    Agendado: 0,
    'Em negociação': 0,
    Concluído: 0
  });

  const [loadingPagination, setLoadingPagination] = useState({
    novasOportunidades: false,
    novoContato: false,
    emNegociacao: false,
    concluido: false
  });

  const getColorStatus = (lead, where) => {
    switch (true) {
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == true &&
        !where:
        return '#006217';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == true &&
        where === 'bg':
        return 'tw-bg-[#006217]';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == false &&
        !where:
        return '#AA2C23';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == false &&
        where === 'bg':
        return 'tw-bg-[#AA2C23]';
      case lead?.SOLICITOU_CONTATO__c === 'true' && !where:
        return '#FF5000';
      case lead?.SOLICITOU_CONTATO__c === 'true' && where === 'bg':
        return 'tw-bg-[#FF5000]';
      case where === 'bg':
        return 'tw-bg-[#001E64]';
      default:
        return '#001E64';
    }
  };

  const getLoadingStatus = (colName: string) => {
    if (colName === 'Novas Oportunidades') {
      return loadingPagination.novasOportunidades;
    }
    if (colName === 'Agendado') {
      return loadingPagination.novoContato;
    }
    if (colName === 'Em negociação') {
      return loadingPagination.emNegociacao;
    }
    if (colName === 'Concluído') {
      return loadingPagination.concluido;
    }
  };
  const [loading, setLoading] = useState(false);
  const [filterLink, setFilterLink] = useState({ query: '', headers: {} });
  const [status, setStatus] = useState('');

  const [idDroppable, setIdDroppable] = useState('');
  const userRef = useRef('12312333');
  const [isLoadingInfiniteScroll, setIsLoadingInfiniteScroll] = useState(false);

  const [activeButton, setActiveButton] = useState(false);
  const [dragResult, setDragResult] = useState<any>();
  const [lead, setLead] = useState<any>({
    name: '',
    email: '',
    cel: '',
    campaign: '',
    id: '',
    status: '',
    cpf: '',
    id_mdm: '',
    data_criacao: 0,
    segmento: '',
    lote: '',
    data_campanha: '',
    objetivo_campanha: '',
    descritivo_campanha: ''
  });

  const objStatusPages = [
    {
      status: 'Novas Oportunidades',
      currentPage: currentPageOportunidades
    },
    { status: 'NovoContato', currentPage: currentPageNovoContato },
    { status: 'EmNegociacao', currentPage: currentPageEmNegociacao },
    { status: 'Concluido', currentPage: currentPageConcluido }
  ];

  const rollbackDragEnd = (result: any) => {
    const { source, destination } = result;
    const sourceColumn = leads[source.droppableId];
    const destColumn = leads[destination.droppableId];

    const sourceItems = [...sourceColumn.items];
    const destItems = [...destColumn.items];

    const [removed] = destItems.splice(destination.index, 1);
    sourceItems.splice(source.index, 0, removed);

    setActiveButton(true);
    setStepState(0);

    setLeads({
      ...leads,
      [source.droppableId]: {
        ...sourceColumn,
        items: sourceItems
      },
      [destination.droppableId]: {
        ...destColumn,
        items: destItems
      }
    });
    onClose();
  };

  const copyText = (text: string) => {
    navigator.clipboard.writeText(text.replace(/[^A-Z0-9]+/gi, ''));
    toast({
      position: 'bottom',
      description: 'Texto copiado com sucesso.',
      status: 'success',
      duration: 2000,
      isClosable: true
    });
  };

  const copyEmail = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({
      position: 'bottom',
      description: 'Texto copiado com sucesso.',
      status: 'success',
      duration: 2000,
      isClosable: true
    });
  };

  const openStepModal = (result: any) => {
    onOpen();
    setDragResult(result);
  };

  const onDragEnd = (result: any, leads: any, setLeads: any) => {
    if (
      !(
        userRef.current === filterObject?.headers?.login ||
        !filterObject?.headers?.login
      )
    ) {
      toast({
        position: 'top',
        description:
          'Você não tem permissão para realizar essa ação. Apenas o vendedor responsável pelo lead pode realizar alterações.',
        status: 'error',
        duration: 4000,
        isClosable: true
      });

      return;
    }

    if (!result.destination) return;
    const { source, destination } = result;
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = leads[source.droppableId];
      const destColumn = leads[destination.droppableId];

      if (sourceColumn.id > destColumn.id) return;

      openStepModal(result);

      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];

      let [removed] = sourceItems.splice(source.index, 1);
      setLead({ ...removed });
      setStatus(destColumn.status);

      removed = {
        ...removed,
        last_modification: format(new Date(), 'dd/MM/yyyy HH:mm')
      };
      destItems.splice(destination.index, 0, removed);
      setIdDroppable(destination.droppableId);
      setLeads({
        ...leads,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems
        }
      });
    } else {
      const column = leads[source.droppableId];
      const copiedItems = [...column.items];

      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);

      setLeads({
        ...leads,
        [source.droppableId]: {
          ...column,
          items: copiedItems
        }
      });
    }
  };

  const setReason = (reason: string) => {
    switch (reason) {
      case 'lgpd-bloqueado':
        return 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato';
      case 'nao-responde':
        return 'Não responde | sem interação nos contatos realizados';
      case 'dados-invalidos':
        return 'Dados inválidos';
      case 'preco':
        return 'Preço';
      case 'fora-rede':
        return 'Fora da rede credenciada | Fora da área de abrangência | Localização';
      case 'concorrencia':
        return 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor';
      case 'cnpj-inativo':
        return 'CNPJ inativo | Emissão de certidão negativa';
      case 'mei-menos':
        return 'MEI menos de 6 meses';
      case 'pj-1-vida':
        return 'PJ para 1 vida';
      case 'ja-contratou':
        return 'Já contratou';
      case 'converteu-saude':
        return 'Interesse em outros produtos | Converteu Saúde';
      case 'converteu-odonto':
        return 'Interesse em outros produtos | Converteu Odonto';
      case 'converteu-vida':
        return 'Interesse em outros produtos | Converteu Vida';
      case 'converteu-viagem':
        return 'Interesse em outros produtos | Converteu Viagem';
      case 'sem-interesse':
        return 'Não teve interesse';
      case 'recusa-sula':
        return 'Recusa SulAmérica DPS';
      default:
        return 'Nenhum motivo';
    }
  };

  const updateLeadDroppable = (
    destiny_droppable: string,
    status: string,
    lead: any,
    changes: any
  ) => {
    const itemsDestiny = leads[destiny_droppable].items;

    const indexLead = itemsDestiny.findIndex((item) => {
      return item.ID_LEAD__c === lead.ID_LEAD__c;
    });

    if (status === 'NovoContato') {
      const newValuesLead = {
        ...lead,
        STATUS__c: status,
        DATA_AGENDAMENTO__c: {
          _seconds: changes?.data_agendamento / 1000,
          _nanoseconds: 0
        }
      };
      itemsDestiny[indexLead] = newValuesLead;

      //Alteração de indicadores de status
      setQtdState((prevState) => {
        return {
          ...prevState,
          [lead.STATUS__c]: prevState[lead.STATUS__c] - 1
        };
      });

      setQtdState((prevState) => {
        return { ...prevState, [status]: prevState[status] + 1 };
      });
    }
    if (status === 'EmNegociacao') {
      const newValuesLead = {
        ...lead,
        ABORDAGEM_N2__c: changes?.abordagem_n2,
        STATUS__c: status
      };
      itemsDestiny[indexLead] = newValuesLead;
    }
    if (status === 'Concluido') {
      const newValuesLead = {
        ...lead,
        ABORDAGEM__c: changes?.abordagem,
        ABORDAGEM_N2__c: changes?.abordagem_n2,
        PRODUTOS__c: changes?.produtos,
        STATUS__c: status
      };
      itemsDestiny[indexLead] = newValuesLead;
    }

    setLeads({
      ...leads,
      [destiny_droppable]: {
        ...leads[destiny_droppable],
        items: itemsDestiny
      }
    });
  };

  const searchStatus = (status: string) => {
    switch (status) {
      case 'Novas Oportunidades':
        return 'Novas Oportunidades';
      case 'Fazer novo contato':
        return 'NovoContato';
      case 'Agendado':
        return 'NovoContato';
      case 'Em negociação':
        return 'EmNegociacao';
      case 'Concluído':
        return 'Concluido';
      default:
        return '-';
    }
  };

  const getFiltersPath = (lastItem: string | number, leadStatus: string) => {
    const path = lastItem
      ? `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&status=${leadStatus}&cursor=${lastItem}`
      : `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&status=${leadStatus}`;

    return path;
  };

  const getFiltersModalPath = (
    leadStatus: string,
    lastItem: string | number
  ) => {
    let queryStatus = '';
    let filterFormatQuery = {
      ...filterObject.query
    };
    if (orderBy.direcao !== '') {
      filterFormatQuery = {
        ...filterObject.query,
        ...orderBy
      };
    }
    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === '' ||
        filter === 'status'
      ) {
        delete filterFormatQuery[filter];
      }
    }
    const filterURL = '' + new URLSearchParams(filterFormatQuery).toString();

    queryStatus =
      `${filterURL !== '' ? filterURL : ''}` + '&status=' + leadStatus;

    const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&${queryStatus}${
      lastItem ? '&cursor=' + lastItem : ''
    }`;

    return path;
  };

  const handleFilters = async () => {
    setLoading(true);
    setLoadingFilters(true);
    let filterFormatQuery = {
      ...filterObject.query
    };
    if (orderBy.direcao !== '') {
      filterFormatQuery = {
        ...filterObject.query,
        ...orderBy
      };
    }

    const filterFormatHeader = {
      ...filterObject.headers
    };

    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === ''
      ) {
        delete filterFormatQuery[filter];
      }
    }

    for (const filter in filterFormatHeader) {
      if (
        filterFormatHeader[filter] === null ||
        filterFormatHeader[filter] === ''
      ) {
        delete filterFormatHeader[filter];
      }
    }
    const filterURL = '&' + new URLSearchParams(filterFormatQuery).toString();

    setCurrentPageOportunidades(1);
    setCurrentPageNovoContato(1);
    setCurrentPageEmNegociacao(1);
    setCurrentPageConcluido(1);

    if (filterFormatQuery.status) {
      const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=200${
        filterURL !== '&' ? filterURL : ''
      }`;

      const { data } = await apiSensedia.get(path, {
        headers: { ...filterFormatHeader }
      });

      setQtdState({
        Concluido: 0,
        Concluído: 0,
        EmNegociacao: 0,
        Agendado: 0,
        NovoContato: 0,
        'Em negociação': 0,
        'Novas Oportunidades': 0
      });

      const filteredLeads = {
        concluidos:
          data.leads.filter((lead) => lead.STATUS__c === 'Concluido') || [],
        emNegociacao:
          data.leads.filter((lead) => lead.STATUS__c === 'EmNegociacao') || [],
        novoContato:
          data.leads.filter((lead) => lead.STATUS__c === 'NovoContato') || [],
        oportunidades:
          data.leads.filter(
            (lead) => lead.STATUS__c === 'Novas Oportunidades'
          ) || []
      };
      const indicadoresObj = {};

      indicadoresObj[data.leads[0]?.STATUS__c] = data.quantidade_leads;

      if (data.leads.length > 0) {
        setQtdState({ ...indicadoresObj });
      }

      const objLeads = filteredLeads;

      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: objLeads.oportunidades,
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: objLeads.novoContato,
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: objLeads.emNegociacao,
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: objLeads.concluidos,
          id: 4,
          status: 'Concluido'
        }
      };

      setFilterLink({ query: path, headers: { ...filterFormatHeader } });
      setLeads(cards);
      setLoading(false);
      setLoadingFilters(false);
      return;
    } else {
      const path = `${filterURL !== '&' ? filterURL : ''}`;

      const responses = await Promise.all(
        objStatusPages
          .map((params) => {
            if (params.status !== 'nao-atendeu') {
              return apiSensedia.get(
                getFiltersPath(undefined, params.status) + path,
                {
                  headers: { ...filterFormatHeader }
                }
              );
            }
          })
          .filter((item) => Boolean(item))
      ).catch((e) => {
        const errorObj = e?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || e?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? e.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (e?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(e?.response?.data?.message || errorObj?.message) && (
                  <>{e.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
        throw e;
      });

      const leadsObj = {};
      const indicadoresObj = {};
      const tipo = responses[0].data.tipo;

      responses.forEach((item) => {
        if (item.data.leads?.length > 0) {
          leadsObj[item.data.leads[0].STATUS__c] = item.data.leads;
          indicadoresObj[item.data.leads[0].STATUS__c] =
            item.data.quantidade_leads;
        }
      });

      const objLeads = {
        tipo: tipo,
        concluidos: leadsObj['Concluido'] || [],
        emNegociacao: leadsObj['EmNegociacao'] || [],
        novoContato: leadsObj['NovoContato'] || [],
        oportunidades: leadsObj['Novas Oportunidades'] || []
      };

      setQtdState(indicadoresObj);

      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: objLeads.oportunidades,
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: objLeads.novoContato,
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: objLeads.emNegociacao,
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: objLeads.concluidos,
          id: 4,
          status: 'Concluido'
        }
      };
      setFilterLink({ query: path, headers: { ...filterFormatHeader } });
      setLeads(cards);
      setLoadingFilters(false);
      setLoading(false);
    }
  };

  const getData = async () => {
    setLoading(true);

    try {
      const responses = await Promise.all(
        objStatusPages
          .map((params) => {
            if (params.status !== 'nao-atendeu') {
              return apiSensedia.get(getFiltersPath(undefined, params.status), {
                params: {
                  'tipo-consulta': 'kanban'
                }
              });
            }
          })
          .filter((item) => Boolean(item))
      ).catch((e) => {
        const errorObj = e?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || e?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? e.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (e?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(e?.response?.data?.message || errorObj?.message) && (
                  <>{e.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });

        throw e;
      });

      const leadsObj = { 'Novas oportunidades': 0 };
      const indicadoresObj = {};
      const tipo = responses[0].data.tipo;

      responses.forEach((item) => {
        if (item.data.leads?.length > 0) {
          leadsObj[item.data.leads[0].STATUS__c] = item.data.leads;
          indicadoresObj[item.data.leads[0].STATUS__c] =
            item.data.quantidade_leads;
        }
      });

      setQtdState(indicadoresObj);
      const objLeads = {
        tipo: tipo,
        concluidos: leadsObj['Concluido'] || [],
        emNegociacao: leadsObj['EmNegociacao'] || [],
        novoContato: leadsObj['NovoContato'] || [],
        oportunidades: leadsObj['Novas Oportunidades'] || []
      };

      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: objLeads.oportunidades,
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: objLeads.novoContato,
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: objLeads.emNegociacao,
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: objLeads.concluidos,
          id: 4,
          status: 'Concluido'
        }
      };

      setLeads(cards);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: [],
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: [],
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: [],
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: [],
          id: 4,
          status: 'Concluido'
        }
      };
      setLeads(cards);
      setLoading(false);
    }
  };

  const loadMoreCards = async (status: string, id: string) => {
    const statusMapping = {
      Oportunidades: 'Novas Oportunidades'
    };

    const formattedStatus: LeadStatus = statusMapping[status] || status;

    const currentPage = objStatusPages.map((statusPage) => {
      if (statusPage.status === formattedStatus) {
        return statusPage.currentPage + 1;
      }
    });

    const currentPageFiltered = currentPage.find(
      (item) => item !== null && item !== undefined
    );

    if (
      (formattedStatus === 'Novas Oportunidades' &&
        loadingPagination.novasOportunidades) ||
      (formattedStatus === 'NovoContato' && loadingPagination.novoContato) ||
      (formattedStatus === 'EmNegociacao' && loadingPagination.emNegociacao) ||
      (formattedStatus === 'Concluido' && loadingPagination.concluido)
    )
      return;

    if (leads[id]?.items?.length === qtdState[formattedStatus]) {
      return;
    }
    setIsLoadingInfiniteScroll(true);

    try {
      switch (formattedStatus) {
        case 'Novas Oportunidades':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novasOportunidades: true
          }));
          break;
        case 'NovoContato':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novoContato: true
          }));
          break;
        case 'EmNegociacao':
          setLoadingPagination((prevState) => ({
            ...prevState,
            emNegociacao: true
          }));
          break;
        case 'Concluido':
          setLoadingPagination((prevState) => ({
            ...prevState,
            concluido: true
          }));
          break;
      }
      let response;

      if (filterObject === initalFilters) {
        response = await apiSensedia
          .get(
            getFiltersPath(
              leads[id].items[leads[id].items.length - 1].ID_LEAD__c,
              formattedStatus
            ),
            {
              params: {
                'tipo-consulta': 'kanban'
              }
            }
          )
          .catch((e) => {
            const errorObj = e?.toJSON();
            toast({
              position: 'top',
              description: (
                <Box>
                  <Text>
                    {' '}
                    Ocorreu um erro. Esvazie o cache do navegador, aguarde
                    alguns minutos e tente fazer login novamente, se persistir,
                    por favor entrar em contato.
                  </Text>
                  <Text>
                    {errorObj?.status && (
                      <>
                        <br />
                        <b>Detalhes:</b>
                        <br />
                      </>
                    )}
                    {(errorObj?.status || e?.response?.data?.statusCode) && (
                      <>{errorObj.status ?? e.response.data.statusCode}</>
                    )}
                    {errorObj?.status &&
                      (e?.response?.data?.message || errorObj?.message) &&
                      ' - '}
                    {(e?.response?.data?.message || errorObj?.message) && (
                      <>{e.response.data.message ?? errorObj.message}</>
                    )}
                  </Text>
                </Box>
              ),
              duration: 15000,
              isClosable: true,
              status: 'error'
            });
            throw e;
          });
      } else {
        response = await apiSensedia.get(
          getFiltersModalPath(
            formattedStatus,
            leads[id].items[leads[id].items.length - 1].ID_LEAD__c
          ),
          {
            headers: { ...filterLink.headers },
            params: {
              'tipo-consulta': 'kanban'
            }
          }
        );
      }

      switch (formattedStatus) {
        case 'Novas Oportunidades':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novasOportunidades: false
          }));
          setCurrentPageOportunidades(currentPageFiltered);
          break;
        case 'NovoContato':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novoContato: false
          }));
          setCurrentPageNovoContato(currentPageFiltered);
          break;
        case 'EmNegociacao':
          setLoadingPagination((prevState) => ({
            ...prevState,
            emNegociacao: false
          }));
          setCurrentPageEmNegociacao(currentPageFiltered);
          break;
        case 'Concluido':
          setLoadingPagination((prevState) => ({
            ...prevState,
            concluido: false
          }));
          setCurrentPageConcluido(currentPageFiltered);
          break;
      }

      const obj1 = leads[id];
      const obj2 = response.data.leads;

      const mergedObj = {
        ...obj1,
        items: [...obj1.items, ...obj2]
      };

      const newLeads = {
        ...leads,
        [id]: mergedObj
      };

      setLeads(newLeads);
    } catch (error) {
      console.log(error);
    }

    setIsLoadingInfiniteScroll(false);
  };

  const handleScroll = (event: any, item: any, id: string) => {
    const div = event.target;
    const status = item.status;
    const valScroll = Math.trunc(div.scrollHeight - div.scrollTop);
    // console.log('medidas', valScroll, div.clientHeight);
    const atBottom =
      valScroll === div.clientHeight || valScroll === div.clientHeight + 1;

    if (atBottom) {
      loadMoreCards(status, id);
    }
  };

  const searchVisualized = (visualized: boolean, arrayVisualized: any) => {
    if (visualized === true) {
      return <AiOutlineEye size="1.1rem" />;
    }
    return <IoEyeOffOutline size="1.1rem" />;
  };

  const getVisualizedStatus = (
    visualized: boolean,
    arrayVisualized: any
  ): 'visualizado' | 'nao-visualizado' => {
    if (visualized === true) {
      return 'visualizado';
    }
    return 'nao-visualizado';
  };

  const ShowOrHidePhone = ({
    phone,
    celphone,
    canShow
  }: ShowOrHidePhoneProps) => {
    const formatCel = (number = '') => {
      if (!number) return '';

      let formating = String(number).replace(/\D/g, '');

      formating = formating.replace(/^0/, '');

      if (formating.length >= 12) {
        formating = formating.slice(2);
        if (formating.length === 10) {
          formating = formating.replace(
            /^(\d\d)(\d{4})(\d{4}).*/,
            '($1) $2-$3'
          );
          return formating;
        }
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length === 11) {
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length > 10) {
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length > 5) {
        formating = formating.replace(
          /^(\d\d)(\d{4})(\d{0,4}).*/,
          '($1) $2-$3'
        );
      } else if (formating.length > 2) {
        formating = formating.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
      } else {
        formating = formating.replace(/^(\d*)/, '($1)');
      }
      return formating;
    };

    const getTelephoneOrCellPhoneNumber = (telephone: any, cell: any) => {
      const telephoneFormatted = telephone?.replace(/\D/g, '');
      const cellFormatted = cell?.replace(/\D/g, '');

      let phoneNumber = '';

      if (
        cellFormatted &&
        telephoneFormatted &&
        telephoneFormatted?.length >= 10 &&
        cellFormatted?.length >= 10
      ) {
        phoneNumber = `${cellFormatted} / ${telephoneFormatted}`;
      } else if (telephoneFormatted && telephoneFormatted?.length >= 10) {
        phoneNumber = `${telephoneFormatted}`;
      } else if (cellFormatted && cellFormatted?.length >= 10) {
        phoneNumber = `${cellFormatted}`;
      } else {
        phoneNumber = '';
      }

      return phoneNumber;
    };
    if (!canShow) {
      const ddd = phone.slice(0, 2);

      return (
        <>
          <p>{ddd}</p>
          <div className="tw-w-[5.73188rem] tw-h-[1.48188rem] tw-bg-[#ececec] tw-blur-[2px]" />
        </>
      );
    } else return <p>{getTelephoneOrCellPhoneNumber(phone, celphone)}</p>;
  };

  const checkHasVisualization = (
    userId: string,
    LEAD_VISUALIZADO__c: boolean
  ) => {
    return LEAD_VISUALIZADO__c === true;
  };

  const getTypeUser = async () => {
    setLoading(true);
    try {
      const dadosLogin = await getDadosLogin();

      userRef.current = dadosLogin.codeNac || null;
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTypeUser();

    if (initalFilters === filterObject) {
      getData();
    } else {
      handleFilters();
    }
  }, [filterObject, orderBy]);

  return (
    <>
      <Box>
        <DragDropContext
          onDragEnd={(result) => {
            onDragEnd(result, leads, setLeads);
          }}
        >
          {!loading ? (
            <HStack>
              {Object.entries(leads).map(([columnId, column], index) => {
                return (
                  <Box key={columnId}>
                    <StepsLead
                      color={`${column.color}`}
                      text={column.name}
                      value={qtdState[searchStatus(column.name)]}
                    />
                    <Box
                      ml="2vh"
                      pointerEvents={
                        getLoadingStatus(column.name) ? 'none' : undefined
                      }
                    >
                      <Droppable droppableId={columnId} key={columnId}>
                        {(provided) => {
                          if (column.items.length <= 0) {
                            return (
                              <Box
                                display="flex"
                                flexDir="column"
                                h="80vh"
                                w={{ base: '20vw', sm: '19vw' }}
                                border="dashed rgba(0, 0, 0, 0.15) 0.13rem"
                                alignItems="center"
                                justify="center"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                <Box
                                  mt="15vh"
                                  display="flex"
                                  flexDirection="column"
                                  align="center"
                                >
                                  <VectorIcon />
                                  <Text w="10vw" fontSize="2vh" mt="1vh">
                                    Clique e arraste os cards para alterar o
                                    status
                                  </Text>
                                </Box>
                                {provided.placeholder}
                              </Box>
                            );
                          }
                          return (
                            <Box
                              display="flex"
                              flexDir="column"
                              h="80vh"
                              w={{ base: '19vw', sm: '19vw' }}
                              overflowY="scroll"
                              overflowX="hidden"
                              alignItems="center"
                              onScroll={(e) => {
                                handleScroll(e, column, columnId);
                              }}
                              sx={{
                                '&::-webkit-scrollbar': {
                                  width: '0.4rem',
                                  borderRadius: '8px',
                                  backgroundColor: `rgba(0, 0, 0, 0.05)`
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  borderRadius: '8px',
                                  backgroundColor: `#939393`
                                }
                              }}
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {column.items.map((item, index) => {
                                return (
                                  <Draggable
                                    key={item.ID_LEAD__c}
                                    draggableId={item.ID_LEAD__c}
                                    index={index}
                                  >
                                    {(provided) => {
                                      return (
                                        <Box
                                          display="flex"
                                          flexDir="column"
                                          bg="#fff"
                                          borderRadius="1.5vh"
                                          justify="flex-start"
                                          m="1vh"
                                          borderLeft={`${getColorStatus(
                                            item,
                                            null
                                          )} solid 0.5vh`}
                                          w={{ base: '18vw' }}
                                          p="2vh"
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                        >
                                          <Box
                                            display="flex"
                                            alignItems="flex-start"
                                            justifyContent="space-between"
                                          >
                                            <Box
                                              fontWeight="bold"
                                              fontSize="2.1vh"
                                            >
                                              {item.NOME__c || ''}
                                              {item?.CreatedDate && (
                                                <Box
                                                  display="flex"
                                                  justifyContent="flex-start"
                                                  alignItems="center"
                                                  fontSize="2vh"
                                                  mb="0.4rem"
                                                  fontWeight={'normal'}
                                                  cursor="pointer"
                                                >
                                                  <Box
                                                    mr="0.4rem"
                                                    fontSize="1.6vh"
                                                    overflowWrap="break-word"
                                                    wordBreak="break-word"
                                                  >
                                                    {format(
                                                      new Date(
                                                        item?.CreatedDate
                                                      ),
                                                      'dd/MM/yyyy'
                                                    )}{' '}
                                                    às{' '}
                                                    {format(
                                                      new Date(
                                                        item?.CreatedDate
                                                      ),
                                                      'HH:mm'
                                                    )}
                                                  </Box>
                                                </Box>
                                              )}
                                            </Box>
                                            <Box>
                                              {item?.SOLICITOU_CONTATO__c ===
                                                'true' && (
                                                <FireIcon w="1.5rem" h="2rem" />
                                              )}
                                            </Box>
                                          </Box>
                                          {item?.PDN_Reaberto__c === true && (
                                            <Box my="0.4rem">
                                              <Text
                                                bg={getColorStatus(item, null)}
                                                px="0.4rem"
                                                w={'max-content'}
                                                minW="3rem"
                                                whiteSpace={'nowrap'}
                                                borderRadius={'1rem'}
                                                py="0.1rem"
                                                textAlign={'center'}
                                                color={'white'}
                                              >
                                                {item?.PDN_Reaberto__c === true
                                                  ? 'Lead Reaberto'
                                                  : ''}
                                              </Text>
                                            </Box>
                                          )}
                                          {item.EMAIL__c && (
                                            <Box
                                              display="flex"
                                              justifyContent="flex-start"
                                              alignItems="center"
                                              fontSize="2vh"
                                              mb="0.4rem"
                                              cursor="pointer"
                                              onClick={() => {
                                                copyEmail(item.EMAIL__c);
                                              }}
                                            >
                                              <Box
                                                mr="0.4rem"
                                                fontSize="1.6vh"
                                                overflowWrap="break-word"
                                                wordBreak="break-word"
                                              >
                                                {item.EMAIL__c}
                                              </Box>
                                              <MdOutlineFileCopy
                                                size="1.9vh"
                                                color="grey"
                                              />
                                            </Box>
                                          )}
                                          {getTelephoneOrCellPhoneNumber(
                                            item.TELEFONE__c,
                                            item.CELULAR__c
                                          ) && (
                                            <Box
                                              display="flex"
                                              justifyContent="flex-start"
                                              alignItems="center"
                                              mb="0.4rem"
                                              fontSize="1.6vh"
                                              overflowWrap="break-word"
                                              wordBreak="break-word"
                                              cursor="pointer"
                                              onClick={() => {
                                                checkHasVisualization(
                                                  userRef.current,
                                                  item.LEAD_VISUALIZADO__c
                                                ) &&
                                                  copyText(
                                                    getTelephoneOrCellPhoneNumber(
                                                      item.TELEFONE__c,
                                                      item.CELULAR__c
                                                    )
                                                  );
                                              }}
                                            >
                                              <ShowOrHidePhone
                                                phone={item.TELEFONE__c || ''}
                                                celphone={item.CELULAR__c || ''}
                                                canShow={checkHasVisualization(
                                                  userRef.current,
                                                  item.LEAD_VISUALIZADO__c
                                                )}
                                              />
                                              <MdOutlineFileCopy
                                                size="1.9vh"
                                                color="grey"
                                              />
                                            </Box>
                                          )}

                                          {item.Campanha__c ===
                                          'Sem Campanha' ? (
                                            <></>
                                          ) : (
                                            <Box
                                              my="1.5vh"
                                              p="0.1rem"
                                              borderRadius="1rem"
                                              bg={`${getColorStatus(
                                                item,
                                                null
                                              )}`}
                                              w={{ base: '9vw', sm: '13vw' }}
                                              fontSize="1.5vh"
                                              textColor="#fff"
                                              display="flex"
                                              justifyContent="center"
                                            >
                                              <span>
                                                {item.Campanha__c?.length >= 20
                                                  ? item.Campanha__c?.substring(
                                                      0,
                                                      28
                                                    ) + '...'
                                                  : item.Campanha__c}
                                              </span>
                                            </Box>
                                          )}

                                          {item?.PRODUTOS__c?.length > 0 ? (
                                            <Box my="0.4rem">
                                              <Text fontWeight="bold">
                                                Produto
                                              </Text>

                                              <Flex flexWrap={'wrap'} gap={2}>
                                                {item.PRODUTOS__c.map(
                                                  (product, index) => {
                                                    return (
                                                      <Text
                                                        key={index}
                                                        bg={getColorStatus(
                                                          item,
                                                          null
                                                        )}
                                                        px="0.4rem"
                                                        w={'max-content'}
                                                        whiteSpace={'nowrap'}
                                                        borderRadius={'1rem'}
                                                        py="0.1rem"
                                                        color={'white'}
                                                      >
                                                        {getProductName(
                                                          product
                                                        ) || ''}
                                                      </Text>
                                                    );
                                                  }
                                                )}
                                              </Flex>
                                            </Box>
                                          ) : (
                                            <Box my="0.4rem">
                                              <Text fontWeight="bold">
                                                Produto
                                              </Text>
                                              <Text
                                                bg={getColorStatus(item, null)}
                                                px="0.4rem"
                                                w={'max-content'}
                                                minW="3rem"
                                                whiteSpace={'nowrap'}
                                                borderRadius={'1rem'}
                                                py="0.1rem"
                                                textAlign={'center'}
                                                color={'white'}
                                              >
                                                {getProductName(
                                                  item.PDN_ProdutoAtual__c
                                                ) || '-'}
                                              </Text>
                                            </Box>
                                          )}

                                          {item?.NOME_CORRETOR__c && (
                                            <Box my="0.4rem">
                                              <Text fontWeight="bold">
                                                Corretora
                                              </Text>
                                              <Text>
                                                {item.NOME_CORRETOR__c || ''}
                                              </Text>
                                            </Box>
                                          )}
                                          {item?.DATA_AGENDAMENTO__c &&
                                            item?.STATUS__c ===
                                              'NovoContato' && (
                                              <Box
                                                p="0.1rem"
                                                borderRadius="1rem"
                                                fontSize="0.8rem"
                                                display="flex"
                                                flexDir={'column'}
                                                alignItems="start"
                                                mb="0.4rem"
                                              >
                                                <Text
                                                  fontSize="1rem"
                                                  fontWeight={'bold'}
                                                >
                                                  Agendamentos
                                                </Text>
                                                <Flex gap="1">
                                                  <span>
                                                    {format(
                                                      new Date(
                                                        item.DATA_AGENDAMENTO__c
                                                          ?._seconds * 1000 || 0
                                                      ),
                                                      'dd/MM/yyyy'
                                                    )}{' '}
                                                    às{' '}
                                                    {format(
                                                      new Date(
                                                        item.DATA_AGENDAMENTO__c
                                                          ?._seconds * 1000 || 0
                                                      ),
                                                      'HH:mm'
                                                    )}{' '}
                                                    -{' '}
                                                  </span>
                                                  <Text
                                                    bg="#001E64"
                                                    w="fit-content"
                                                    textColor={'white'}
                                                    px="0.3rem"
                                                    rounded={'md'}
                                                  >
                                                    {
                                                      dateFnsDayPeriod[
                                                        format(
                                                          new Date(
                                                            item
                                                              .DATA_AGENDAMENTO__c
                                                              ?._seconds *
                                                              1000 || 0
                                                          ),
                                                          'B',
                                                          { locale: ptBR }
                                                        )
                                                      ]
                                                    }
                                                  </Text>
                                                </Flex>
                                              </Box>
                                            )}
                                          {item?.ABORDAGEM_N2__c &&
                                            item?.STATUS__c ===
                                              'EmNegociacao' && (
                                              <Box my="0.4rem">
                                                <Text fontWeight="bold">
                                                  Em Negociação
                                                </Text>
                                                <Text>
                                                  {item?.ABORDAGEM_N2__c ===
                                                    'cotacao' &&
                                                    'Cotação enviada'}
                                                  {item?.ABORDAGEM_N2__c ===
                                                    'transmissao' &&
                                                    'Proposta transmitida'}
                                                </Text>
                                              </Box>
                                            )}
                                          {item?.ABORDAGEM_N2__c &&
                                            item?.STATUS__c === 'Concluido' &&
                                            item?.ABORDAGEM__c === false && (
                                              <Box my="0.4rem">
                                                <Text fontWeight="bold">
                                                  Motivo
                                                </Text>
                                                <Text>
                                                  {setReason(
                                                    item?.ABORDAGEM_N2__c
                                                  )}
                                                </Text>
                                              </Box>
                                            )}
                                          <LeadBtnTooltipComponent
                                            tooltip={
                                              getVisualizedStatus(
                                                item.LEAD_VISUALIZADO__c,
                                                item.USUARIOS_VISUALIZACOES__c
                                              ) === 'visualizado'
                                                ? 'Lead visualizado'
                                                : 'Lead não visualizado'
                                            }
                                            side="bottom"
                                            arrowOffset={100}
                                          >
                                            <Box
                                              display="flex"
                                              justifyContent="flex-start"
                                            >
                                              <Link
                                                to={
                                                  '/corretor/leads/' +
                                                  item.ID_LEAD__c
                                                }
                                                state={{
                                                  isGestor: !(
                                                    userRef.current ===
                                                      filterObject?.headers
                                                        ?.login ||
                                                    !filterObject?.headers
                                                      ?.login
                                                  )
                                                }}
                                                className={`tw-flex tw-items-center tw-gap-2 tw-justify-center tw-w-[100%] tw-text-center tw-h-[5vh] tw-cursor-pointer tw-text-white tw-rounded-full tw-font-[1.8vh] ${getColorStatus(
                                                  item,
                                                  'bg'
                                                )}`}
                                              >
                                                {searchVisualized(
                                                  item.LEAD_VISUALIZADO__c,
                                                  item.USUARIOS_VISUALIZACOES__c
                                                )}
                                                <span> Ver Detalhes</span>
                                              </Link>
                                            </Box>
                                          </LeadBtnTooltipComponent>
                                        </Box>
                                      );
                                    }}
                                  </Draggable>
                                );
                              })}
                              {provided.placeholder}
                            </Box>
                          );
                        }}
                      </Droppable>
                      {getLoadingStatus(column.name) ? (
                        <HStack justifyContent="center">
                          <Spinner />
                        </HStack>
                      ) : (
                        <></>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </HStack>
          ) : (
            <Flex w="100%" justify="center">
              <Spinner />
            </Flex>
          )}
        </DragDropContext>
        <Box justifyContent="center" alignItems="center">
          <Modal
            closeOnOverlayClick={false}
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
          >
            <ModalOverlay />
            <ModalContent>
              <ModalChangeStatus
                lead={lead}
                status={status}
                isMobile={false}
                onOpenModal={onOpen}
                onCloseModal={onClose}
                rollbackLead={rollbackDragEnd}
                dragResult={dragResult}
                updateLead={updateLeadDroppable}
              />
            </ModalContent>
          </Modal>
        </Box>
      </Box>
    </>
  );
};
